import React, {useEffect, useState} from "react";
import {Skeleton, Typography} from "@mui/material";
import {useTheme} from  "../../../contexts/theme";
import Grid from "@mui/material/Grid";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface MatchDaysSkeletonProps{
    skeletonNumber: number;
}

const MatchDaysMamSkeleton: React.FC<MatchDaysSkeletonProps> = ({skeletonNumber}) => {
    const theme = useTheme();
    const [skeletons, setSkeletons] = useState<number[]>([]);
    const skeletonStyle = {backgroundColor: theme.palette.white, height: '30px', borderRadius: theme.border.radius.md};

    useEffect(() => {
        setSkeletons(new Array(skeletonNumber).fill(0))
    }, [skeletonNumber]);

    return (
        <>
            {skeletons.map((skeleton, index) => (
                    <Grid item xs={12} key={'matchDaySkeleton' + index}>
                <Grid
                    container
                alignItems={'center'}
                height={'50px'}
                sx={{
        backgroundColor: theme.palette.blurredBlue,
            borderBottom: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}`,
            borderTop: index === 0 ? `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}` : ''
    }}
>
    <Grid item xs={4}>
    <Skeleton sx={{...skeletonStyle, width: '30%'}}/>
    </Grid>
    <Grid item xs={4} display={'flex'} justifyContent={'center'}>
    <Skeleton sx={{...skeletonStyle, width: '50%'}}/>
    </Grid>
    <Grid item xs={4} display={'flex'} justifyContent={'end'}>
        <ArrowDropDownIcon/>
        </Grid>
        </Grid>
        </Grid>
))}
    </>
)
}

export default MatchDaysMamSkeleton